import { init as apm } from '@elastic/apm-rum';

function getEnv() {
  const { host } = document.location;
  switch (host) {
    case 'admin-dev.control.events':
      return 'dev';
    case 'admin-pre.control.events':
      return 'pre';
    case 'admin.control.events':
      return 'prod';
    default:
      return 'local';
  }
}

// ========================================================
// Elastic AMP
// ========================================================

export default apm({
  serviceName: __APP_NAME__,
  serverUrl: 'https://apm.control.events',
  environment: getEnv(),
  active: __PROD__ && !__INHOUSE__,
  hostname: document.location.host,
  serviceVersion: __TAG__,
  captureExceptions: true,
  ignoreTransactions: ['GET /version.json'],
});
